import React, { memo } from 'react';
import styles from './pointTitle.module.scss';

export const PointTitle = memo(({backColor,children}) => {

  return (
		<h3 className={styles.point} style={{ backgroundColor:backColor }}>{children}</h3>
  );
});
